import styles from "./Iframe.module.scss";

export const Iframe = (props) => {
  return (
    <div className={`${props.type === 'youtube' ? styles["embedYoutube"] : '' } ${styles["embedVideo"]}`}
      dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }}
    />
  );
}